import React, { FC, SVGProps, useMemo } from "react";

type SVGIconProps = SVGProps<SVGSVGElement>;

type Props = {
  src: string;
} & SVGIconProps;

const loadSVGIcon = (src: string): FC<SVGIconProps> => {
  return require(`@svgr/webpack!../../assets/icons/${src}.svg`).default;
};

const IconComponent = ({ src, ...rest }: Props) => {
  const Icon = useMemo(() => {
    return loadSVGIcon(src);
  }, [src]);

  return <Icon {...rest} />;
};

export const createIconComponent = (path: string) => {
  return (props: SVGIconProps) => {
    return <IconComponent src={path} {...props} />;
  };
};

export default IconComponent;
